import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

import styles from './OrderConfirmation.styles';
import OrderConfirmation from './OrderConfirmation';

export default compose(withRouter, withStyles(styles))(OrderConfirmation);
